import React from 'react'
import { motion } from 'framer-motion'

/*
 * A utility wrapper component that animates text by letting it (dis)appear on the "key" change.
 */
const AnimatedText: React.FC<{ children: React.ReactNode; trigger: string | number }> = ({ children, trigger }) => {
  return (
    <motion.span
      key={trigger}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.12 }}
    >
      {children}
    </motion.span>
  )
}

export default AnimatedText
